import React from 'react';

export interface MapLegendContextData {
  open: boolean;
  anchorEl: any;
  expandedKey: string;
  handleAccordionChange: (key: string) => void;
  handleClick: (event: React.MouseEvent) => void;
  handleClose: () => void;
}

export const MapLegendContext = React.createContext<MapLegendContextData>({
  open: false,
  anchorEl: null,
  expandedKey: '',
  handleAccordionChange: () => null,
  handleClick: () => null,
  handleClose: () => null,
});
